import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';
import mixGraficaAvanceEstimaciones from '@/components/administracion/ejecucion/estimaciones/reportes/mixGraficaAvanceEstimaciones';

export default {
  name: 'MainGraficaAvancesEstimaciones',
  data() {
    return {
      activarMostrarGrafica: false,
    };
  },
  mixins: [mixGenerarPdf, mixFormatoEstructura, mixGraficaAvanceEstimaciones],
  methods: {
    mostrarGrafica() {
      this.activarMostrarGrafica = true;
      this.$emit('mostrarGrafica');
    },
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfGraficaAvance() {
      this.$emit('generando');
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${this.estimacion.fechaPresentacion} 00:00:0`, this.firmas);

      const grafica = this.mixCalcularPuntosGrafica;
      const graficaConFormato = {
        programado: grafica.programado.map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        financiero: grafica.financiero.map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        programadoP: grafica.programadoPorcentaje.map((p) => `${p}%`),
        financieroP: grafica.financieroPorcentaje.map((p) => `${p}%`),
        numeroMeses: grafica.programado.length,
      };
      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const datos = {
        supervisionExterna: this.getContratoSupervisionExternaEnGraficaAvance
          ?.contratoRelacionado
          ?.contratista?.nombreRazonSocial || '',
      };
      const supervisor = this.getSupervisorEnGraficaAvance || '';
      const firmasFuncionarios = encabezadoReferencia.firmas || [];
      let nombreTemplate = 'templateGraficaAvanceEstimacion';
      if (this.contrato.esObraFinanciada) { nombreTemplate = 'templateGraficaAvanceEstimacion'; }
      graficaConFormato.financiero[0] = '-';
      graficaConFormato.financieroP[0] = '-';

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          grafica,
          graficaConFormato,
          contrato: contratoConFormato,
          estimacion: estimacionConFormato,
          supervisor,
          firmas: firmasFuncionarios,
          datos,
          footer: '',
          encabezadoReferencia,
        },
      }, `${this.contrato.numero}_GraficaAvanceEstimacion_${this.estimacion.numero}`);
      this.generandoPdfGraficaAvanceEstimaciones = false;
      this.$emit('terminando');
    },

  },
  computed: {
    getSupervisorEnGraficaAvance() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoSupervisionExternaEnGraficaAvance() {
      if (this.contrato.contratosRelacionados.length <= 0) return null;
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
  },
};
